import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-file-signature',
    templateUrl: './file-signature.component.svg',
    styleUrls: ['./file-signature.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileSignatureComponent {}
